import axios from "_u/axios"

// 查询列表
export const fReceiptList = (body) => {
    return axios.post("api/finance/receipt/list", body)
}

// 查看明细
export const fReceiptView = (id) => {
    return axios.post("api/finance/receipt/view", { id })
}

// 新增
export const fReceiptAdd = (body) => {
    return axios.post("api/finance/receipt/add", body)
}

// 修改
export const fReceiptUpdate = (body) => {
    return axios.post("api/finance/receipt/update", body)
}

// 查询已收的账单
export const queryReceivedBill = (body) => {
    return axios.post("api/finance/receipt/queryReceivedBill", body)
}

